module.exports = __webpack_public_path__ + "static/img/diamond-green.e357cca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diamond-green.png
// module id = a6Sg
// module chunks = 1